import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type DemoWelcomeLead = {
  name: string;
  company: string;
  storesLabel: string;
  /** Telefone já formatado para exibição. */
  phone: string;
  /** ISO 8601: data do envio, para "Cadastro recebido" e "Membro desde". */
  submittedAt: string;
  whatsappUrl: string;
};

type DemoWelcomeStore = {
  lead: DemoWelcomeLead | null;
  savedAt: number | null;
  setLead: (lead: DemoWelcomeLead) => void;
};

// Lead recém-enviado pelo form de demo, lido pela LP de boas-vindas. Fica no
// sessionStorage para a página sobreviver a um recarregar, mas some ao fechar
// a aba e expira em 30 min: numa aba compartilhada, quem voltar depois pelo
// histórico não vê o crachá de outra pessoa.
const LEAD_TTL_MS = 30 * 60 * 1000;

export const useDemoWelcomeStore = create<DemoWelcomeStore>()(
  persist(
    set => ({
      lead: null,
      savedAt: null,
      setLead: lead => set({ lead, savedAt: Date.now() }),
    }),
    {
      name: "demo-welcome",
      storage: createJSONStorage(() => sessionStorage),
      merge: (persisted, current) => {
        const saved = persisted as Partial<DemoWelcomeStore> | undefined;
        const isExpired =
          !saved?.savedAt || Date.now() - saved.savedAt > LEAD_TTL_MS;
        return isExpired ? current : { ...current, ...saved };
      },
    }
  )
);
